import React from 'react'
import { connect, useSelector } from 'react-redux';
import { teamDetailsStyle as styles } from './teamDetails.tailwind';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { MY_ACCOUNT_TABS } from '../../../../myAccountTabsData';
import routeConstant from '../../../../../../lib/constants/routeConstant';
import { setMyAccountActiveTab } from '../../../../../../redux/slices/publicSlice';
import Button from '../../../../../shared/Button/Button';

const TeamDetails = ({ setActiveTab }) => {
  const navigate = useNavigate();
  const { gameDetails } = useSelector(state => state.scorer);

  const handleBack = () => {
    setActiveTab(MY_ACCOUNT_TABS.VIEW_GAMES); // Dispatch action to set active tab to VIEW_GAMES
    navigate(routeConstant.MY_ACCOUNT_PAGE, { replace: true }); // Navigate to MY_ACCOUNT_PAGE
  }
  
  return (
    <div className={styles.outerContainer}>
      <Button variant="outline" className={styles.back_btn} onClick={handleBack}>
        <ArrowBack fontSize='22px' />
        <span>Go Back</span>
      </Button>

      <div className={styles.team_details_wrpr}>
        {(gameDetails?.leagueSlug === 'mens-college-basketball' || gameDetails?.leagueSlug === 'womens-college-basketball') && (
          <div className={styles.genderBanner}>
            <span className={styles.genderText}>
              {gameDetails?.leagueSlug === 'mens-college-basketball' ? "MEN'S" : "WOMEN'S"}
            </span>
          </div>
        )}

        <div className={styles.teamDetailsContainer}>
          <img src={gameDetails?.homeTeamImage} alt={gameDetails?.homeTeamName} className={styles.image} />
          <p className={styles.teamName}>{gameDetails?.homeTeamName}</p>
        </div>

        <p className={styles.versusText}>V/S</p>

        <div className={styles.teamDetailsContainer}>
          <p className={styles.teamName}>{gameDetails?.awayTeamName}</p>
          <img src={gameDetails?.awayTeamImage} alt={gameDetails?.awayTeamName} className={styles.image} />
        </div>
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  setActiveTab: (data) => dispatch(setMyAccountActiveTab(data))
})

export default connect(null, mapDispatchToProps)(TeamDetails);